import { render, staticRenderFns } from "./SelectEcomProduct.vue?vue&type=template&id=6226acea&scoped=true"
import script from "./SelectEcomProduct.vue?vue&type=script&lang=js"
export * from "./SelectEcomProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectEcomProduct.vue?vue&type=style&index=0&id=6226acea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226acea",
  null
  
)

export default component.exports